export class Device {
  static AGENT = navigator.userAgent.toLowerCase()
  static MOBILE = !!navigator.maxTouchPoints
  static TABLET = this.MOBILE && Math.max(window.innerWidth, window.innerHeight) > 1000
  static PHONE = this.MOBILE && !this.TABLET
  // Touch-enabled laptops/desktops report maxTouchPoints but keep a mouse/trackpad as primary input
  static TOUCH_DESKTOP = this.MOBILE && !!window.matchMedia?.('(hover: hover) and (pointer: fine)').matches
  static WEBP = true
  static GL = (() => {
    if (typeof window === 'undefined') return

    const contextOptions = {
      failIfMajorPerformanceCaveat: true,
    }

    let canvas = document.createElement('canvas')
    let gl = canvas.getContext('webgl2', contextOptions)

    const result = !!gl

    gl = null
    canvas = null

    return result
  })()
}